import { required, optional } from 'AppReact/schema';
import uuidv4 from 'uuid-browser/v4';
export default {
    id: optional('integer'),
    modal:required('string'),
    color:required('string'),
    licensePlate: required('string'),
    state: required('string'),
    
    hasError: optional('boolean'),
    modalError: optional('string'),
    colorError: optional('string'),
    licensePlateError: optional('string'),
    stateError: optional('string'),
}

export const defaultVehicle = {
    modal: '',
    color: '',
    licensePlate: '',
    state: '',

    hasError: false,
    modalError: '',
    colorError: '',
    licensePlateError: '',
    stateError: '',
}
